import onGetClinicActTeams from './onGetClinicActTeams';
import onGetActTeamsAvailable from './onGetActTeamsAvailable';
import onGetAllActTeamsAvailable from './onGetAllActTeamsAvailable';
import onGetActTeamsShowAll from './onGetActTeamsShowAll';
import onGetClinicActTeam from './onGetClinicActTeam';
import onArchiveActTeam from './onArchiveActTeam';
import onRestoreActTeam from './onRestoreActTeam';
import onGetAllActTeams from './onGetAllActTeams';
import onCreateClinicActTeam from './onCreateClinicActTeam';
import onEditClinicActTeam from './onEditClinicActTeam';

export default {
  onGetActTeamsAvailable,
  onGetAllActTeamsAvailable,
  onGetActTeamsShowAll,
  onGetClinicActTeams,
  onGetClinicActTeam,
  onArchiveActTeam,
  onRestoreActTeam,
  onGetAllActTeams,
  onCreateClinicActTeam,
  onEditClinicActTeam,
};
